export const TESTNET_ACRE_TOKEN = '0x51AB97113e9C87E3d8af7fecf911219ceE235BF7';
export const TESTNET_WALLET = '0xb90E873d8F959F36Dd40afa7F4E30C10907Ae8dA';
export const MAINNET_ACRE_TOKEN = '0x77dDA3913e57F1879eF2FFb4cC339E670deEe67c';
